/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Prize_OptionalInputs */



/**
* | output |
* | --- |
* | "Prize (optional)" |
*
* @param {Raffle_Prize_OptionalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_prize_optional = /** @type {((inputs?: Raffle_Prize_OptionalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Prize_OptionalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prix (optionnel)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Premio (opcional)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Prêmio (opcional)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Premio (opzionale)")
	return /** @type {LocalizedString} */ ("Prize (optional)")
});